import request from '@/util/request'

const state = {
  lock_obj: null,
  lock_pra: null,
  lock_paz: null,
  lock: false,
  lockTimer: null,
  lockTimeout: 50000,
  alive: false,
  aliveTimer: null,
  aliveTimeout: 60000,
  sistemaInfo:
    sessionStorage.getItem('sistemaInfo') != 'undefined'
      ? JSON.parse(sessionStorage.getItem('sistemaInfo'))
      : null,
}
const getters = {
  getLockObj: state => state.lock_obj,
  getLockPra: state => state.lock_pra,
  getLockPaz: state => state.lock_paz,
  getLock: state => state.lock,
  getAlive: state => state.alive,
  sistemaInfo: state => state.sistemaInfo,
}
const actions = {
  lockObj({ commit, dispatch }, { obj_id, lock }) {
    if (state.lock_obj && (obj_id !== state.lock_obj || lock === false)) {
      dispatch('unlockObj')
    }

    if (!lock) {
      return
    }

    dispatch('postLockObj', { obj_id, lock })
    commit('SET_LOCK_OBJ', obj_id)
    commit('SET_LOCK', lock)
    state.lock_obj = obj_id
    state.lock = lock

    if (!state.lockTimer) {
      state.lockTimer = setInterval(() => {
        let obj_id = state.lock_obj
        let lock = state.lock
        dispatch('postLockObj', { obj_id, lock })
      }, state.lockTimeout)
    }
  },
  unlockObj({ commit, dispatch }) {
    let obj_id = state.lock_obj
    let lock = false
    dispatch('postLockObj', { obj_id, lock })

    commit('SET_LOCK_OBJ', null)
    commit('SET_LOCK', false)
    state.lock_obj = null
    state.lock = false

    clearInterval(state.lockTimer)
    state.lockTimer = null
  },
  lockPra({ commit, dispatch }, { pra_id, lock }) {
    if (state.lock_pra && (pra_id !== state.lock_pra || lock === false)) {
      dispatch('unlockPra')
    }

    if (!lock) {
      return
    }

    dispatch('postLockPra', { pra_id, lock })
    commit('SET_LOCK_PRA', pra_id)
    commit('SET_LOCK', lock)
    state.lock_pra = pra_id
    state.lock = lock

    if (!state.lockTimer) {
      state.lockTimer = setInterval(() => {
        let pra_id = state.lock_pra
        let lock = state.lock
        dispatch('postLockPra', { pra_id, lock })
      }, state.lockTimeout)
    }
  },
  unlockPra({ commit, dispatch }) {
    let pra_id = state.lock_pra
    let lock = false
    dispatch('postLockPra', { pra_id, lock })

    commit('SET_LOCK_PRA', null)
    commit('SET_LOCK', false)
    state.lock_pra = null
    state.lock = false

    clearInterval(state.lockTimer)
    state.lockTimer = null
  },
  lockPaz({ commit, dispatch }, { paz_id, lock }) {
    if (state.lock_paz && (paz_id !== state.lock_paz || lock === false)) {
      dispatch('unlockPaz')
    }

    if (!lock) {
      return
    }

    dispatch('postLockPaz', { paz_id, lock })
    commit('SET_LOCK_PAZ', paz_id)
    commit('SET_LOCK', lock)
    state.lock_paz = paz_id
    state.lock = lock

    if (!state.lockTimer) {
      state.lockTimer = setInterval(() => {
        let paz_id = state.lock_paz
        let lock = state.lock
        dispatch('postLockPaz', { paz_id, lock })
      }, state.lockTimeout)
    }
  },
  unlockPaz({ commit, dispatch }) {
    let paz_id = state.lock_paz
    let lock = false
    dispatch('postLockPaz', { paz_id, lock })

    commit('SET_LOCK_PAZ', null)
    commit('SET_LOCK', false)
    state.lock_paz = null
    state.lock = false

    clearInterval(state.lockTimer)
    state.lockTimer = null
  },
  keepAlive({ commit, dispatch }, alive) {
    commit('SET_ALIVE', alive)
    state.alive = alive

    dispatch('postAlive')

    if (!alive) {
      clearInterval(state.aliveTimer)
      state.aliveTimer = null
      return
    }
    if (!state.aliveTimer) {
      state.aliveTimer = setInterval(() => {
        dispatch('postAlive')
      }, state.aliveTimeout)
    }
  },
  postAlive({ commit }) {
    return request({
      url: '/keep-alive',
      method: 'post',
      data: {
        alive: state.alive,
      },
    }).then(resp => {
      if (state.alive) {
        commit('SET_SISTEMA_INFO', resp.sistemos_informavimas)
      }
      if (!state.alive) {
        commit('SET_ACCESS_TOKEN', null)
      }
    })
  },
  postLockObj({ commit }, { obj_id, lock }) {
    if (process.env.VUE_APP_LOCAL === 'local') {
      return
    }
    if (lock && !obj_id) {
      return
    }
    return request({
      url: '/document-lock',
      method: 'post',
      data: {
        obj_id: obj_id,
        lock: lock,
      },
    }).then(resp => {
      //
    })
  },
  postLockPra({ commit }, { pra_id, lock }) {
    if (process.env.VUE_APP_LOCAL === 'local') {
      return
    }
    if (lock && !pra_id) {
      return
    }
    return request({
      url: 'ntrpaslaugos/document-lock',
      method: 'post',
      data: {
        pra_id: pra_id,
        lock: lock,
      },
    }).then(resp => {
      //
    })
  },
  postLockPaz({ commit }, { paz_id, lock }) {
    if (process.env.VUE_APP_LOCAL === 'local') {
      return
    }
    if (lock && !paz_id) {
      return
    }
    return request({
      url: 'ntrpaslaugos/pazyma-lock',
      method: 'post',
      data: {
        paz_id: paz_id,
        lock: lock,
      },
    }).then(resp => {
      //
    })
  },
  sistemaInfo({ commit }, payload) {
    commit('SET_SISTEMA_INFO', payload)
  },
}
const mutations = {
  SET_LOCK_OBJ(state, data) {
    state.lock_obj = data
  },
  SET_LOCK_PRA(state, data) {
    state.lock_pra = data
  },
  SET_LOCK_PAZ(state, data) {
    state.lock_paz = data
  },
  SET_LOCK(state, data) {
    state.lock = data
  },
  SET_ALIVE(state, data) {
    state.alive = data
  },
  SET_SISTEMA_INFO(state, data) {
    state.sistemaInfo = data
    sessionStorage.setItem('sistemaInfo', JSON.stringify(data))
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
